import Carousel from '@components/Carousel'
import step1 from '@plug-core/assets/hyperliquid-steps/step-1.png'
import step2 from '@plug-core/assets/hyperliquid-steps/step-2.png'
import step3 from '@plug-core/assets/hyperliquid-steps/step-3.png'
import step4 from '@plug-core/assets/hyperliquid-steps/step-4.png'
import step5 from '@plug-core/assets/hyperliquid-steps/step-5.png'
import { usePerpsSettings } from '@plug-core/state'
import { Button, Heading, Sheet, Text } from '@ui'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface TutorialStep {
  title: string
  description: string
  visual: string
}

const TUTORIAL_STEPS: TutorialStep[] = [
  {
    title: 'Master Perpetual Futures',
    description:
      'With perpetual futures, you are not just trading assets, you are trading what you think will happen next',
    visual: step1,
  },
  {
    title: 'Go Long',
    description:
      'Going long means you believe the price will increase. You buy a contract expecting to profit from upward price movements.',
    visual: step2,
  },
  {
    title: 'Go Short',
    description:
      'You think the price will go down. If you are right, you can earn. If it goes up, you lose',
    visual: step3,
  },
  {
    title: 'Adjusting Leverage',
    description: 'Leverage increases the potential profits and losses when the token price changes',
    visual: step4,
  },
  {
    title: 'Liquidation',
    description:
      'If the price hits your liquidation price your position will be closed. Using higher leverage increases the risk of being liquidated',
    visual: step5,
  },
]

interface TutorialSlideProps {
  step: TutorialStep
}

const TutorialSlide: React.FC<TutorialSlideProps> = ({ step }) => {
  return (
    <div className="flex min-w-full flex-col">
      <div className="flex flex-col items-center gap-4">
        <Heading level={3} align="center">
          {step.title}
        </Heading>

        <Text tone="fg-2" align="center">
          {step.description}
        </Text>

        <img src={step.visual} width={200} height={200} alt="" />
      </div>
    </div>
  )
}

interface PerpsTutorialProps {
  visible: boolean
}

const PerpsTutorial: React.FC<PerpsTutorialProps> = ({ visible }) => {
  const { t } = useTranslation()
  const { setHasSeenIntro } = usePerpsSettings()

  const handleComplete = () => {
    setHasSeenIntro(true)
  }

  return (
    <Sheet
      open={visible}
      onClose={() => setHasSeenIntro(true)}
      title={t('perps.learnBasics')}
      hideTitle
    >
      <div className="flex flex-col gap-8">
        <div className="flex flex-1 flex-col gap-4">
          <Carousel itemSize={480} spacingPx={16} hideControls showPager>
            {TUTORIAL_STEPS.map((step, index) => (
              <TutorialSlide key={index} step={step} />
            ))}
          </Carousel>
        </div>
        <Button variant="primary" fullWidth onClick={handleComplete}>
          {t('common.understood')}
        </Button>
      </div>
    </Sheet>
  )
}

export default PerpsTutorial
